/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { ICittaStoreLocationMobileViewProps } from './citta-store-location-mobile';


export default (props: ICittaStoreLocationMobileViewProps) => {
    const { CittaStores, StoreDetail } = props
    return (
        <Module {...CittaStores}>
            {StoreDetail}
        </Module>


    );
};
